import React, { useState, useEffect } from 'react';

import Image from 'next/image';

import BrandInitials from '@/components/cards/BrandInitials';

interface AutoHeightImageProps {
  src: string;
  alt: string;
  width: number;
  className?: string;
  priority?: boolean;
}

const AutoHeightImage: React.FC<AutoHeightImageProps> = ({
  src,
  alt,
  width,
  className,
  priority = false,
}) => {
  const [aspectRatio, setAspectRatio] = useState(1);

  useEffect(() => {
    const img = new window.Image();
    img.src = src;
    img.onload = () => {
      setAspectRatio(img.width / img.height);
    };
  }, [src]);

  return (
    <div
      style={{
        width: `${width}px`,
        height: `${width / aspectRatio}px`,
        position: 'relative',
      }}
      className={className}
    >
      {src && src.length > 0 ? (
        <Image
          src={src}
          alt={alt}
          fill
          sizes="33vw"
          style={{ objectFit: 'contain' }}
          priority={priority}
          className="rounded-sm"
          unoptimized
        />
      ) : (
        <BrandInitials name={'卡'} size="md" className="rounded-sm" />
      )}
    </div>
  );
};

export default AutoHeightImage;
